import React, { useEffect, useLayoutEffect, useRef } from 'react';
import lkflModal from '../../../../services/lkflModal';
import { LkflModalContainer } from '../../../../components/ModalWindow/LkflModalContainer';
import { useSelector } from 'react-redux';
import { selectRouter } from '../../utils/selectors';

function ModalInit() {
  const modalRef = useRef();
  const router = useSelector(selectRouter);

  useLayoutEffect(() => {
    lkflModal.init(modalRef);
  }, []);

  useEffect(() => {
    modalRef?.current?.hide();
  }, [router.pathname]);

  return <LkflModalContainer ref={modalRef} />;
}

export default ModalInit;
